import React from 'react';
import { Link } from 'react-router-dom';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { DropdownLink } from 'src/components/DropdownLink';

import { LINKS } from './GlobalAppNavigation';

interface AdoptionDropdownProps {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
}

export const AdoptionDropdown = ({ isOpen, onToggle }: AdoptionDropdownProps): React.ReactElement => (
  <DropdownLink title="Adoption" isOpen={isOpen} onToggle={onToggle} openOnHover={true}>
    <div css={adoptionDropdownContentStyles}>
      <Link to={LINKS.ROVO.href || '/'} css={adoptionLinkStyles} onClick={() => onToggle(false)}>
        {LINKS.ROVO.text}
      </Link>
    </div>
  </DropdownLink>
);

const adoptionDropdownContentStyles = css({
  padding: `${token('space.200')} ${token('space.100')}`,
  backgroundColor: '#FFFFFF',
  textAlign: 'left',
  width: 'fit-content',
  whiteSpace: 'nowrap',
});

const adoptionLinkStyles = css({
  display: 'block',
  padding: `${token('space.100')} ${token('space.150')}`,
  textDecoration: 'none',
  color: token('color.text'),
  fontFamily: 'Charlie Text, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  borderRadius: '4px',

  '&:hover': {
    color: token('color.link'),
    textDecoration: 'none',
  },
});
